import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sx?: SxProps
  [prop: string]: any
}

export const UnpinIcon = ({ sx, ...props }: Props) => (
  <SvgIcon
    viewBox="0 0 24 24"
    sx={{ width: '24px', height: '24px', color: 'secondary.main', ...sx }}
    {...props}
  >
    <path
      fill="inherit"
      fillRule="evenodd"
      d="m7.765 8.274-3.18-3.181L3 3.517l1.316-1.316L21 18.885l-1.316 1.316-2.966-2.975-.992-.985-.483 2.417-1.415 1.414-4.242-4.243-4.95 4.95-1.414-1.414 4.95-4.95-4.243-4.242 1.414-1.415 2.422-.484Zm6.26 6.268-.482 2.416-6.5-6.5 2.42-.484 4.563 4.568Z"
      clipRule="evenodd"
    />
    <path
      fill="inherit"
      d="m18.778 9.466-2.399 2.398 1.415 1.414 2.398-2.398.707.707 1.415-1.414-8.486-8.486-1.413 1.415.707.707-2.399 2.399 1.414 1.414 2.399-2.399 4.242 4.243Z"
    />
  </SvgIcon>
)

UnpinIcon.defaultProps = {
  sx: null,
}
